import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstace from "src/utilities/axios";

let initialState = {
  isLoading: false,
  data: {},
  error: null,
}

export const getHomeAdvice = createAsyncThunk(
  "homeAdvice/getHomeAdvice",
  async (_, thunkApi) => {
    try {
      const { data } = await axiosInstace.get("/home/advice");
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateHomeAdvice = createAsyncThunk(
  "homeAdvice/updateHomeAdvice",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstace.put("/home/advice", args);
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const homeAdviceSlice = createSlice({
  name: "homeAdvice",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getHomeAdvice.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getHomeAdvice.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data || {};
        state.error = null;
      })
      .addCase(getHomeAdvice.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload.error;
      })

      .addCase(updateHomeAdvice.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateHomeAdvice.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data || {};
        state.error = null;
      })
      .addCase(updateHomeAdvice.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload.error;
      })
  }
});

export default homeAdviceSlice.reducer;